export default __webpack_public_path__ + "static/media/Fluentd.7c6c0f28.md";